module.exports = __webpack_public_path__ + "static/media/GERD-New Patient GERD Intake-2@3x.39c41cf3.png";